import { useCreateBlockNote } from "@blocknote/react";
import EditableImage from "../../../../components/EditableImage";
import { Input } from "@oc-labs/wt-storybook";
import "@blocknote/core/fonts/inter.css";
import { BlockNoteView } from "@blocknote/mantine";
import "@blocknote/mantine/style.css";
import { Map } from '@vis.gl/react-maplibre';
import 'maplibre-gl/dist/maplibre-gl.css';

export default function InputParamField({ type, keyName, value, onChange, variant = "form", base64 = true }) {
  if (type === "longtext") {
    const editor = useCreateBlockNote({
      initialContent: value ? JSON.parse(value) : undefined
    });

    const wrapperClasses = variant === "modal"
      ? "w-[700px] min-h-[200px] max-h-[400px] overflow-y-auto overflow-x-hidden border border-gray-300 rounded-md p-4"
      : "w-full border border-gray-300 rounded-md p-4";


    return (
      <div className={wrapperClasses}>
        <label className="block mb-2 text-xs">
          {keyName
            ?.replace(/([a-z])([A-Z])/g, "$1 $2")
            .toLowerCase()
            .replace(/^./, str => str.toUpperCase())}
        </label>
        <BlockNoteView
          editor={editor}
          theme="light"
          onChange={() => {
            onChange(JSON.stringify(editor.document));
          }}
        />
      </div>
    );
  }

  if (type === "image") {
    return (<EditableImage
      base64={base64}
      image={value}
      onImageChange={onChange}
    />);
  }

  if (type === "map") {
    return (<Map
      onMove={({ viewState }) => {
        const { longitude, latitude, zoom } = viewState;
        onChange(JSON.stringify({ longitude, latitude, zoom }));
      }}
      initialViewState={{
        longitude: -100,
        latitude: 40,
        zoom: 3.5
      }}
      style={{ width: '100%', height: 400 }}
      mapStyle={`https://api.maptiler.com/maps/streets/style.json?key=${import.meta.env.VITE_MAP_KEY}`}
    />);
  }

  return (
    <Input
      label={keyName
        ?.replace(/([a-z])([A-Z])/g, "$1 $2")
        .toLowerCase()
        .replace(/^./, str => str.toUpperCase())}
      value={value}
      type={type}
      onChange={(e) => onChange(e.target.value)}
      placeholder={`Enter ${keyName}`}
    />);
}